<div class="layout-row align-end gap-2px responsive-column container m-b-20 m-t-10">
  <!--
  <button mat-raised-button color="primary" *LOSxHasPermission="'UPDATE_LOANPRODUCT'" (click)="copyProduct()">
    <fa-icon icon="copy" class="m-r-10"></fa-icon>{{'labels.buttons.Create' | translate}} {{'labels.text.Copy' | translate}}
  </button>
  -->
  <button mat-raised-button color="primary" *LOSxHasPermission="'UPDATE_LOANPRODUCT'" (click)="exportDefinition()">
    <fa-icon icon="download" class="m-r-10"></fa-icon>{{ 'labels.buttons.Export' | translate }}
  </button>
  <button mat-raised-button color="primary" [routerLink]="['../edit']" *LOSxHasPermission="'UPDATE_LOANPRODUCT'">
    <fa-icon icon="edit" class="m-r-10"></fa-icon>{{ 'labels.buttons.Edit' | translate }}
  </button>
</div>

<LOSx-loan-product-summary
  [action]="'view'"
  [loanProduct]="loanProduct"
  [useDueForRepaymentsConfigurations]="useDueForRepaymentsConfigurations"
  [paymentAllocations]="loanProduct.paymentAllocation"
  [creditAllocations]="loanProduct.creditAllocation"
  [supportedInterestRefundTypes]="loanProduct.supportedInterestRefundTypes"
>
</LOSx-loan-product-summary>
